import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EsqueletoComponent } from './esqueleto/esqueleto.component';

const routes: Routes = [
  {
    path: '',
    component: EsqueletoComponent,
    children: [
      {
        path: 'ordenes',
        loadChildren: () =>
          import('../ordenes/ordenes.module').then((m) => m.OrdenesModule),
        title: 'Órdenes',
      },
      {
        path: 'domicilios',
        loadChildren: () =>
          import('../domicilios/domicilios.module').then(
            (m) => m.DomiciliosModule,
          ),
        title: 'Domicilios',
      },
      {
        path: 'clientes',
        loadChildren: () =>
          import('../clientes/clientes.module').then((m) => m.ClientesModule),
        title: 'Clientes',
      },
      {
        path: 'paquetes',
        loadChildren: () =>
          import('../paquetes/paquetes.module').then((m) => m.PaquetesModule),
        title: 'Paquetes',
      },
      {
        path: 'planillas',
        loadChildren: () =>
          import('../planillas/planillas.module').then(
            (m) => m.PlanillasModule,
          ),
        title: 'Planillas',
      },
      {
        path: 'reportes',
        loadChildren: () =>
          import('../reportes/reportes.module').then((m) => m.ReportesModule),
        title: 'Reportes',
      },
      {
        path: '',
        loadChildren: () =>
          import('../adhoc/adhoc.module').then((m) => m.AdhocModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NucleoRoutingModule {}
